export default __webpack_public_path__ + "static/media/ADD2.872e043d.jpg";